"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var js_1 = __importDefault(require("@bugsnag/js"));
var plugin_react_1 = __importDefault(require("@bugsnag/plugin-react"));
var acs_sc_web_platform_api_1 = require("@adsk/acs-sc-web-platform-api");
var withContext_1 = __importDefault(require("./withContext"));
var initializeBugsnag = function (apiKey, context) {
    var notify = (function () { return undefined; });
    var BugsnagErrorBoundary = (function (_a) {
        var children = _a.children;
        return children;
    });
    if (!['development', 'test'].includes(process.env.NODE_ENV || '') ||
        window.BUGSNAG) {
        var bugsnagClient = js_1.default.start({
            apiKey: apiKey || '',
            plugins: [new plugin_react_1.default(React)],
            releaseStage: (0, acs_sc_web_platform_api_1.getEnv)(),
            context: context,
        });
        notify = bugsnagClient.notify;
        var reactPlugin = bugsnagClient.getPlugin('react');
        if (reactPlugin) {
            BugsnagErrorBoundary = (0, withContext_1.default)(reactPlugin.createErrorBoundary(React));
        }
        else {
            console.error('Bugsnag React Plugin not found.');
        }
    }
    return { notify: notify, BugsnagErrorBoundary: BugsnagErrorBoundary };
};
exports.default = initializeBugsnag;
